import Link from 'next/link';
import { rgba } from 'polished';
import { black, blue, white } from '@/lib/colours';
import { Button, type ButtonProps } from '@/primitives';

export interface NavButtonLinkProps extends ButtonProps {
  isSubnav?: boolean;
  selected?: boolean;
}

export function NavButtonLink({
  isSubnav,
  selected,
  ...props
}: NavButtonLinkProps) {
  return (
    <Button
      {...props}
      component={Link}
      sx={{
        justifyContent: 'flex-start',
        px: '14px',
        py: 0,
        width: '100%',
        color: white[900],
        textTransform: 'capitalize',
        ...(selected
          ? {
              background: blue[isSubnav ? 950 : 600],
              '&:hover': {
                background: rgba(blue[isSubnav ? 950 : 600], 0.25),
              },
            }
          : {
              '&:hover': {
                background: rgba(black[600], 0.25),
              },
            }),
        '.MuiButton-startIcon': {
          padding: '12px',
          svg: {
            fontSize: '24px',
          },
        },
        '.MuiButton-endIcon': {
          marginLeft: 'auto',
        },
      }}
    />
  );
}
